import React from 'react';

export default class AutoCompleteText extends React.Component {
    constructor (props) {
        super(props);
        this.items = [
            'Is hydroxychloroquine a treatment for COVID-19?',
            'Hydroxychloroquine is a treatment for COVID-19?',
            'Will drinking alcohol prevent COVID-19?',
            'Will drinking bleach prevent COVID-19?',
            'Alcohol prevents COVID-19?',
            'Bleach prevents COVID-19?',
            'Does eating pepper cure COVID-19?',
            'Do mosquitos transmit COVID-19?',
            'Is injecting disinfectant as cure for COVID-19?',
            'What are the symptoms of COVID?',
            'COVID-19 symptoms',
            'Is wearing a mask bad for you?',
            'What are the treatments for COVID-19?',
            'Can cold weather kill the COVID-19 virus?',
            'Does garlic prevent COVID-19?',
            'Can antibiotics cure COVID-19?',
            'Can thermometers detect COVID-19?',
        ];
        this.state = {
            suggestions: [],
            text: '',
        };

    }

    onTextChanged = (e) => {
        const value = e.target.value;
        let suggestions = [];
        if (value.length > 0) {
            const regex = new RegExp(`^${value}`, 'i');
            suggestions = this.items.sort().filter(v => regex.test(v));
        }
        this.setState(() => ({ suggestions, text: value }));
    }

    suggestionSelected (value) {
        this.setState(() => ({
            text: value,
            suggestions: [],
        }))
    }

    renderSuggestions () {
        const { suggestions } = this.state;
        if (suggestions.length === 0) {
            return null;
        }
        return (
            <ul>
                {suggestions.map((item) => <li onClick={() => this.suggestionSelected(item)}>{item}</li>)}
            </ul>
        );

    }

    render () {
        const { text } = this.state;
        return (
            <div>
                <input id = "userenter" value={text} onChange={this.onTextChanged} type="text" />
                <ul >
                    {this.renderSuggestions()}
                </ul>
            </div>
        );
    }

}